import { statusCategories } from '@atlassian/jira-common-constants/src/index.tsx';

export const isIssueStatusDone = (statusCategoryId: number) => {
	const doneStatusCategoryId =
		statusCategories.StatusCategoryIds[statusCategories.StatusCategoryTypes.DONE];
	return doneStatusCategoryId && doneStatusCategoryId === statusCategoryId;
};
